export enum ConnectionRequestResolutionType {
  Approved = "Approved",
  Rejected = "Rejected",
}

export interface ConnectionRequestResolution {
  type: ConnectionRequestResolutionType;
  /** ISO Date string */
  timestamp: string;
  /** userId */
  resolvedBy: string;
}

export enum ConnectionRequestStatus {
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected",
  Removed = "Removed",
}

export interface MaybeResolved {
  resolution: ConnectionRequestResolution | null;
}

export interface Resolved {
  resolution: ConnectionRequestResolution;
}

export interface ResolvedInput {
  resolutionType: ConnectionRequestResolutionType;
}
